import { RouteProps } from "react-router-dom"
import Loadable from "../components/Loadable"
import getMenus from "../constants/menu.export"
// import AuthModal from '../models/authModal'

export interface AuthorityRouteProps extends RouteProps {
  private?: boolean
}

var routes: AuthorityRouteProps[] = [
  {
    path: "/grid",
    exact: true,
    component: Loadable(() => import("../routes/Grid")),
    private: true,
  },
  // {
  //   path: "/",
  //   exact: true,
  //   component: Loadable(() => import("../routes/Dashboard")),
  //   private: true,
  // },
  // {
  //   path: "/health",
  //   exact: true,
  //   component: Loadable(() => import("../routes/Health")),
  //   private: true,
  // },
  // {
  //   path: "/analysis",
  //   exact: true,
  //   component: Loadable(() => import("../routes/Analysis")),
  //   private: true,
  // },
  // {
  //   path: "/poi",
  //   exact: true,
  //   component: Loadable(() => import("../routes/PoiIndex")),
  //   private: true,
  // },
  // {
  //   path: "/trend",
  //   exact: true,
  //   component: Loadable(() => import("../routes/Trend")),
  //   private: true,
  // },
  // {
  //   path: "/trendAd",
  //   exact: true,
  //   component: Loadable(() => import("../routes/TrendAd")),
  //   private: true,
  // },
  // {
  //   path: "/trendReport",
  //   exact: true,
  //   component: Loadable(() => import("../routes/TrendReport")),
  //   private: true,
  // },
  // {
  //   path: "/assetsReport",
  //   exact: true,
  //   component: Loadable(() => import("../routes/AssetsReport")),
  //   private: true,
  // },
  // {
  //   path: "/brand",
  //   exact: true,
  //   component: Loadable(() => import("../routes/Brand")),
  //   private: true,
  // },
  // {
  //   path: "/tag",
  //   exact: true,
  //   component: Loadable(() => import("../routes/Tag")),
  //   private: true,
  // },
  // {
  //   path: "/grid",
  //   exact: true,
  //   component: Loadable(() => import("../routes/Grid")),
  //   private: true,
  // },
  // {
  //   path: "/graph",
  //   exact: true,
  //   component: Loadable(() => import("../routes/Graph")),
  //   private: true,
  // },
  // {
  //   path: "/graphSearch",
  //   exact: true,
  //   component: Loadable(() => import("../routes/GraphSearch")),
  //   private: true,
  // },
  // {
  //   path: "/singapore",
  //   exact: true,
  //   component: Loadable(() => import("../routes/Singapore")),
  //   private: true,
  // },
  // //用户权限
  // {
  //   path: "/user",
  //   exact: true,
  //   component: Loadable(() => import("../routes/User")),
  //   private: true,
  // },
  {
    path: "/auth",
    exact: true,
    component: Loadable(() => import("../routes/Passport/Auth")),
    private: false,
  },
  {
    path: "/logout",
    exact: true,
    component: Loadable(() => import("../routes/Passport/Logout")),
    private: true,
  },
]
// function addRoute(menus: any[]) {
//   menus &&
//     menus.forEach(menu => {
//       if (menu.entry) {
//         routes.push({
//           path: menu.path,
//           exact: menu.exact,
//           component: Loadable(() => import("../routes/" + menu.entry)),
//           private: menu.private,
//         })
//       }
//       addRoute(menu.children)
//     })
// }
// addRoute(Menus)

export default () => {
  // const {authMenus} = AuthModal()
  let menu = getMenus()
  // let menu = authMenus
  // let pathMap: any = { "/auth": true, "/logout": true, "/brand": true }
  let pathMap: any = { "/auth": true, "/logout": true }
  menu.forEach((m: any) => {
    pathMap[m.path] = true
    m.children &&
      m.children.forEach((m2: any) => {
        pathMap[m2.path] = true
      })
  })

  let r = routes.filter((r: any) => {
    return pathMap[r.path]
  })
  return r
}
